<template>
  <div>
    <div id="login">
      <v-container>
        <div>
          <page-progress :is-loading="loading"/>
          <v-card flat style="background-color: transparent; padding: 0px">
            <v-card-text class="pa-0">
              <v-form ref="loginForm" v-model="validLogin" lazy-validation v-on:submit.prevent
                      style="max-width: 400px">
                <v-container fluid class="pa-0"
                             :style="{'margin-top': $vuetify.breakpoint.mdAndUp ? '75px' : '0px'}">
                  <v-row>
                    <v-col>
                      <span class="text-h4 logo--text font-weight-bold">Log</span>
                      <span class="text-h4 logo--text font-weight-light">In</span>
                    </v-col>
                  </v-row>
                  <v-row class="mt-5">
                    <v-col>
                      <v-text-field
                          outlined
                          dense
                          color="deep-purple accent-4"
                          hide-details="auto"
                          type="email"
                          prepend-inner-icon="mdi-email"
                          v-model="loginData.email"
                          :rules="emailRules"
                          label="Email"
                          key="loginEmail"
                      />
                    </v-col>
                  </v-row>
                  <v-row class="mt-3">
                    <v-col>
                      <v-text-field
                          outlined
                          dense
                          color="deep-purple accent-4"
                          hide-details="auto"
                          prepend-inner-icon="mdi-key"
                          v-model="loginData.password"
                          :rules="[rules.required, rules.min]"
                          label="Password"
                          type="password"
                          key="loginPassword"
                      />
                      <div class="extras" style="float: right;">
                        <a href="#" @click.prevent.stop="onForgotPasswordHandler" class="logo--text">Forgot Password?</a>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row class="mt-3">
                    <v-col>
                      <v-btn
                          color="deep-purple accent-4"
                          class="white--text"
                          block
                          :disabled="!validLogin || loading"
                          @click.prevent.stop="loginHandler"
                      >
                        Login
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </v-card-text>
          </v-card>
        </div>
      </v-container>
    </div>
    <forgot-password
        :show="showForgotPassword"
        @closePopupHandler="closePopupHandler"
        @saveItemHandler="forgotEmailHandler"
    />
    <reset-password
        :show="showResetPassword"
        :item="forgoPassword"
        @closePopupHandler="closePopupHandler"
        @saveItemHandler="savePasswordHandler"
    />
  </div>
</template>

<script>
import Validation from "../mixins/Validation";
import User from "../../services/User";
import ForgotPassword from "../popups/ForgetPassword";
import ResetPassword from "../popups/ResetPassword";
import PageProgress from "../PageProgress";

export default {
  name: "GPLogin",
  components: {PageProgress, ResetPassword, ForgotPassword},
  mixins: [Validation],
  data() {
    return {
      validLogin: false,
      showForgotPassword: false,
      showResetPassword: false,
      loginData: {
        email: '',
        password: '',
        device_name: 'Browser'
      },
      forgoPassword: {
         email: '',
         token: '',
         password: ''
      },
      loading: false,
    }
  },
  mounted() {
    const token = this.$route.query.token;
    const email = this.$route.query.email
    if(token && email) {
      this.resetPasswordHandler(token, email);
    } else {
      this.routeHandler();
    }
  },
  methods: {
    loadingHandler(status) {
      this.loading = status;
      this.validLogin = status;
    },
    loginHandler() {
      const me = this;
      if (!this.$refs.loginForm.validate()) {
        return;
      }

      User.login(me.loginData)
          .then((response) => {
            localStorage.setItem("auth", 'true');
            localStorage.setItem("token", response.data);
            this.$router.push({name: 'Dashboard'});
          })
          .catch((error) => {
            if (error.response.status === 422) {
              this.$store.commit('SET_SNACKBAR', {
                type: 'error',
                text: error.response.data.errors["email"][0]
              });
            }
          })
    },
    onForgotPasswordHandler() {
      this.showForgotPassword = true;
    },
    closePopupHandler() {
      this.showForgotPassword = false;
      this.showResetPassword = false;
      this.routeHandler();
    },
    forgotEmailHandler(item) {
      this.loading = true;
      User
      .forgotPassword(item)
      .then((response)=> {
        const message = response.data.message;
        this.setSnackBar(message, 'info');
        this.loading = false;
      })
      .catch((error)=> {
        this.setSnackBar('The provided email is not found!', 'error');
        this.loading = false;
      })
    },
    resetPasswordHandler(token, email) {
      this.loading = true;
      User
          .resetPassword({token, email})
          .then((response)=> {
            this.forgoPassword = {email, token, password: '', passwordConfirmation: ''};
            this.showResetPassword = true;
            this.loading = false;
          })
          .catch((error)=> {
            this.setSnackBar('The forgot password link is expired!', 'error');
            this.routeHandler();
            this.loading = false;
          })
    },
    savePasswordHandler(item) {
      this.loading = true;
      User
          .saveForgotPassword(item)
          .then((response)=> {
            const message = response.data.message;
            this.setSnackBar(message, 'info');
            this.loading = false;
            this.routeHandler();
          })
          .catch((error)=> {
            this.setSnackBar('The forgot password link is expired!', 'error');
            this.routeHandler();
            this.loading = false;
          })
    },
    setSnackBar(text, type) {
      this.$store.commit('SET_SNACKBAR', {text, type});
    },
    routeHandler() {
      if (Object.keys(this.$route.query).length > 0) this.$router.push({ name: 'Login', query: null });
    }
  }
}
</script>


<style lang="scss" scoped>

#login {
  margin-top: 0px;
}

.extras {
  text-align: center;

  a {
    text-decoration: none;
  }
}

.error-message {
  color: red;
}
</style>
